import ET3Div from "../../../../core/et3-div"
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render"
import { E_CLIENT_PAGE } from "../../../../Types"
import PageTypeButton from "./PageTypeButton"


export const ClientPageType = withLiteObserverAndTheme(() => {
    return (<ET3Div
        width={755}
        height={150}
        alignItems={"flex-start"}
        fDirection={"row"}
        style={{}}
        color={""}
        justifyContent={"flex-start"}
        withShadow={false}
        isExtendable={false}
        isScrollable={false}
        onClick={() => { }}
    >
        <PageTypeButton type={E_CLIENT_PAGE.ALL} />
        <PageTypeButton type={E_CLIENT_PAGE.BREACHE_LEVEL} />
    </ET3Div>)
})

export default ClientPageType